import { apiGet, apiPutNoContent } from "./http";

export interface EnrollmentFormFieldRow {
  id: string;
  label: string;
  type: string;
  required: boolean;
  enabled: boolean;
  placeholder?: string;
  options?: string[];
  isSystem?: boolean;
  order: number;
}

export function fetchEnrollmentFormFields(tenantLegacyId: string) {
  return apiGet<EnrollmentFormFieldRow[]>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/enrollment-form-fields`
  );
}

export function putEnrollmentFormFields(tenantLegacyId: string, fields: EnrollmentFormFieldRow[]) {
  return apiPutNoContent(`/api/tenants/${encodeURIComponent(tenantLegacyId)}/enrollment-form-fields`, fields);
}
